<div class="header-bar">
  <div class="header-left">
    <div class="header-text">Facilities</div>
    <div class="divider"></div>
    <div class="search-box input-box">
      <svg-icon src="assets/svg/magnifier.svg"></svg-icon>

      <mat-form-field>
        <input matInput type="text" [formControl]="searchValueControl" />
      </mat-form-field>
    </div>
    <div class="divider"></div>
    <div class="filter">
      <button mat-button class="icon-btn" (click)="toggleFilterDialog()">
        <svg-icon src="assets/svg/filter.svg" svgClass="grey"></svg-icon>
      </button>
    </div>
  </div>
  <div class="header-center"></div>
  <div class="header-right">
    <button
      *ngIf="hasFacilitiesWrite"
      mat-button
      color="lightGreen"
      (click)="createNewFacility()"
    >
      Create New Facility
    </button>
  </div>
</div>

<div class="facilities-list">
  <div class="container facilities-container">
    <div class="container-header no-bottom-border">
      <div class="text">Existing Facilities</div>
      <div class="options">
        <button
          *ngIf="hasFacilitiesWrite"
          mat-icon-button
          [matMenuTriggerFor]="facilitiesMenu"
        >
          <svg-icon src="assets/svg/ellipsis.svg"></svg-icon>
        </button>
        <mat-menu
          class="mat-menu-elaphant vertical-menu"
          #facilitiesMenu="matMenu"
        >
          <button
            *ngIf="hasFacilitiesWrite"
            class="icon-btn-w-text"
            mat-menu-item
            (click)="createNewFacility()"
          >
            <svg-icon src="assets/svg/plus-circle-white.svg"></svg-icon>
            <span>Create New Facility</span>
          </button>
        </mat-menu>
      </div>
    </div>

    <div
      class="container-content"
      lhpeElementLoader
      #facilityElementLoader="elementloader"
    >
      <table
        #facilitiesTable
        mat-table
        [dataSource]="facilitiesDataSource"
        matSort
      >
        <ng-container matColumnDef="id">
          <th mat-header-cell *matHeaderCellDef>ID</th>
          <td mat-cell *matCellDef="let element">
            {{ element.id }}
          </td>
        </ng-container>

        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            Facility Name
          </th>
          <td mat-cell *matCellDef="let element">{{ element.name }}</td>
        </ng-container>

        <ng-container matColumnDef="address1">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Address</th>
          <td mat-cell *matCellDef="let element">
            {{ element.address1 }}
          </td>
        </ng-container>

        <ng-container matColumnDef="city">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>City</th>
          <td mat-cell *matCellDef="let element">
            {{ element.city }}
          </td>
        </ng-container>

        <ng-container matColumnDef="state">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>State</th>
          <td mat-cell *matCellDef="let element">
            {{ element.state }}
          </td>
        </ng-container>

        <ng-container matColumnDef="zip">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Zip</th>
          <td mat-cell *matCellDef="let element">
            {{ element.zip }}
          </td>
        </ng-container>

        <ng-container matColumnDef="floors">
          <th mat-header-cell *matHeaderCellDef>Floors</th>
          <td mat-cell *matCellDef="let element">
            {{ element.floors.length }}
          </td>
        </ng-container>

        <ng-container matColumnDef="options">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let element" class="options-cell">
            <button
              *ngIf="hasFacilitiesWrite && hasFacilitiesDetail"
              mat-button
              (click)="edit(element)"
              class="icon-btn"
            >
              <svg-icon
                src="assets/svg/pencil.svg"
                svgClass="lightBlue"
              ></svg-icon>
            </button>
            <div
              *ngIf="!(hasFacilitiesWrite && hasFacilitiesDetail)"
              class="empty-btn-space"
            ></div>
            <button
              *ngIf="hasFacilitiesWrite"
              mat-button
              (click)="delete(element)"
              class="icon-btn"
            >
              <svg-icon
                src="assets/svg/trashcan.svg"
                [svgStyle]="{
                  'width.px': '15.25',
                  'height.px': '16.204'
                }"
                svgClass="lightBlue"
              ></svg-icon>
            </button>
            <div *ngIf="!hasFacilitiesWrite" class="empty-btn-space"></div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
      <mat-paginator [pageSizeOptions]="pageSizeOptions" [pageSize]="perPage" (page)="onPageChange($event)"></mat-paginator>
    </div>
  </div>
</div>
